import { Form } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import InputNumber from "../../../../../components/Input/InputNumber.tsx"
import { type SettingsCompanyFormData } from "../SettingsCompanyForm.tsx"

export function CompanyAlertThresholdsFormSection() {
  const { t } = useTranslation()

  return (
    <>
      <Form.Item<SettingsCompanyFormData>
        label={t("settings.company.cashFlowThresholdPercent")}
        name="cash_flow_threshold_percent"
      >
        <InputNumber
          min={0}
          max={100}
          precision={2}
          suffix="%"
          className="w-full"
          placeholder={t(
            "settings.company.cashFlowThresholdPercentPlaceholder"
          )}
        />
      </Form.Item>

      <Form.Item<SettingsCompanyFormData>
        label={t("settings.company.contractTolerancePercent")}
        name="contract_tolerance_percent"
      >
        <InputNumber
          min={0}
          max={100}
          precision={2}
          suffix="%"
          className="w-full"
          placeholder={t(
            "settings.company.contractTolerancePercentPlaceholder"
          )}
        />
      </Form.Item>
    </>
  )
}
